import { fetcher } from "helpers/fetcher";

import { TGetBranchListReq } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getBranchList = async (language: string) => {
  return await fetcher<TGetBranchListReq, any>(ENDPOINT.USER.GET_BRANCH_LIST, {
    headers: {
      [API_HEADER.VERSION]: ENDPOINT.USER.GET_BRANCH_LIST.version,
      [API_HEADER.LANGUAGE]: language,
    },
  });
};

export const queryGetBranchList = async (language: string) => {
  return (await getBranchList(language)).data;
};

queryGetBranchList._key = (language: string) => [
  ENDPOINT.USER.GET_BRANCH_LIST.url,
  language,
];
